import React from 'react';

const HTMLcolored = ({ className = '' }) => {
  return (
    <svg className={className} width="47" height="54" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#E44D26"
          d="M4.27728583 48.601969L0 0h47l-4.2818208 48.5943556L23.4712351 54z"
        />
        <path
          fill="#F16529"
          d="M23.5 49.7086093l15.6168079-4.3567587 3.6742369-41.41807577H23.5z"
        />
        <path
          fill="#EBEBEB"
          d="M23.5 21.9811715h-7.77397l-.5368943-6.0549281H23.5V10.013245H8.76865672l.14062748 1.5863571 1.4439221 16.2944376H23.5zM23.5 37.3588059l-.0259315.0070253-6.5902516-1.810157-.4212893-4.8007073h-5.9401395l.8290263 9.4512309 12.121351 3.4229413L23.5 43.6214509z"
        />
        <path
          fill="#FFF"
          d="M23.5 21.8145695v5.9957124h7.2464679l-.683074 7.7760732L23.5 37.3912744v6.2378647l12.0641418-3.4066368.0885106-1.012973 1.3828653-15.7849242.1435868-1.6100356h-1.5858047zM23.5 10.013245V16.0927152h14.2047891l.1179761-1.3664784.2679392-3.0819732.1406389-1.6310186z"
        />
      </g>
    </svg>
  );
};
export default HTMLcolored;
